module.exports = __webpack_public_path__ + "static/media/confetti.a48cb60a.png";